<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button v-if="allowUpdateExcellent" variant="primary" @click="dialogExcellent()">
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Thêm tác phẩm') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <div class="card mb-1">
      <div class="card-body p-1">
        <div class="row">
          <div class="col-12 col-md-3">
            <b-form-group label="Ngày đăng" class="mb-0">
              <date-picker v-model="loadDateRange" type="datetime" range ref="datetime" :shortcuts="shortcuts"
                :show-time-panel="false" format='DD/MM/YYYY' valueType="format" input-class="form-control"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"></date-picker>
            </b-form-group>
          </div>
          <b-col cols="12" md="6" class="mt-md-0 mt-1 ">

            <b-form-group label="Từ khóa" class="mb-0">
              <b-input-group>
                <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Từ khóa"
                  @keyup.enter="updateSearchQuery" />
                <b-input-group-append>
                  <b-button variant="primary" @click="updateSearchQuery">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body p-0">
        <div class="m-1">
          <b-row>
            <b-col cols="12" sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start d-none d-sm-block">
              <span class="text-muted">Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của {{ dataMeta.of }} mục</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <b-table ref="refListTable" class="table-responsive table-nowrap" :items="itemsData" responsive
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" :sort-desc.sync="isSortDirDesc" show-empty
          empty-text="Không tìm thấy bản ghi nào">
          <template #cell(title)="data">
            <span class="text-wrap text-break link" @click="onPreview(data.item.id, 'show')">{{ data.item.title }} <span
                v-for="(icon, index) in  data.item.content_type" :key="index" :class="`icon` + icon"></span>
            </span>
          </template>
          <template #cell(image)="data">
            <img :src="data.item.image" class="img-thumbnail" width="110" />
          </template>
          <template #cell(status)="data">
            <b-badge :variant="data.item.statusText.color"> {{ data.item.statusText.name }} </b-badge>
          </template>
          <template #cell(actions)="data">
            <div v-for="(button, index) in data.item.listButton" :key="index">
              <b-button v-if="button.type == 'link'" size="sm" :variant="button.color" :title="button.title"
                :to="{ name: button.url, params: { id: data.item.id } }">
                <span class="text-nowrap">
                  <feather-icon :icon="button.icon" />
                </span>
              </b-button>
              <b-button v-if="['undo', 'delete'].includes(button.type)" size="sm" :variant="button.color"
                :title="button.title" @click="updateStatus(button.type, data.item)">
                <span class="text-nowrap">
                  <feather-icon :icon="button.icon" />
                </span>
              </b-button>
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của {{ dataMeta.of }} mục</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <b-modal id="modalState" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop hide-footer
      body-class="p-0" title="Danh sách">
      <dialog-excellent @updateExcellent="handleExcellent" />
    </b-modal>
    <b-modal id="showPreview" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop hide-footer
      title="Xem thử bài viết">
      <article-preview :article_id="article_id" :type_view="type_view" />
    </b-modal>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BPagination, BInputGroupAppend, BInputGroup, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast, allowPermision } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import flatPickr from 'vue-flatpickr-component'
import dialogExcellent from './DialogExcellent.vue'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import moment from 'moment';
import ArticlePreview from './ArticlePreview.vue'
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    dialogExcellent,
    BFormGroup,
    flatPickr,
    DatePicker,
    ArticlePreview
  },
  data() {
    return {
      moment,
      article_id: '',
      type_view: '',
    }
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const refListTable = ref(null)
    const allowUpdateExcellent = ref(false);

    // Table Handlers
    const tableColumns = [
      { key: 'id', sortable: false, class: 'itemid' },
      { key: 'image', sortable: false, label: 'Ảnh', thAttr: { width: '10%' } },
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      { key: 'published_at', sortable: false, label: 'Ngày xuất bản', thAttr: { width: '12%' } },
      { key: 'views', sortable: false, label: 'Lượt xem', thAttr: { width: '12%' }, class: 'text-center' },
    ];
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const type = ref('')
    const status = ref('')
    const localSearchQuery = ref('')
    const itemsData = ref([]);
    const start_date = ref('');
    const end_date = ref('');
    const loading = ref('')
    const from = ref(0)
    const to = ref(0)
    const loadDateRange = ref('')
    const now = new Date()

    const fetchAll = (isPaginate) => {
      isPaginate = isPaginate === undefined ? 0 : isPaginate;
      if (!isPaginate) {
        loading.value = true
      }
      store.dispatch('article/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        start_date: start_date.value,
        end_date: start_date.value,
        card_type: 'published',
        excellent: 1,
        isPaginate
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            if (isPaginate) {
              from.value = result.data.from;
              to.value = result.data.to;
              total.value = result.data.total;
            } else {

              itemsData.value = result.data.data
              setTimeout(() => {
                fetchAll(1);
              }, 1000);
              //total.value = result.data.total;
            }
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = 50
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([perPage, searchQuery, status, start_date, end_date], () => {

      currentPage.value = 1;
      if (!loading.value) {
        fetchAll()
      }
    })

    watch([currentPage], () => {
      if (!loading.value) {
        fetchAll()
      }

    })
    const refetchData = () => {
      fetchAll()
    }

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
    }

    onMounted(() => {
      fetchAll();
      allowUpdateExcellent.value = allowPermision('article.allow_update_excellent');
    })
    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
      { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
      { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] }
    ])

    return {
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      type,
      status,
      loading,
      updateSearchQuery,
      localSearchQuery,
      itemsData,
      allowUpdateExcellent,
      start_date,
      shortcuts,
      end_date,
      loadDateRange
    }
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false);
  },
  methods: {
    onPreview(id, type) {
      this.article_id = id;
      this.type_view = type;
      this.$bvModal.show('showPreview');
    },
    dialogExcellent() {
      this.$bvModal.show('modalState')
    },
    handleExcellent() {
      this.refetchData()
    },
  },
}
</script>,

<style lang="scss">
.link {
  color: #000;
  font-weight: bold;

  &:hover {
    color: #e63631
  }
}

@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
